'use strict';

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioManual = exports.Audio = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _shared = require('./shared');

var _Toolbar = require('../components/Toolbar');

var _LabelList = require('../components/LabelList');

var _LabelList2 = _interopRequireDefault(_LabelList);

var _LabelDropdown = require('../components/LabelDropdown');

var _LabelDropdown2 = _interopRequireDefault(_LabelDropdown);

var _Icon = require('../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    player: {
      position: 'relative',
      '& > wave': {
        width: 'calc(100% + 1px)'
      },
      '& .wavesurfer-region': {
        zIndex: [5, '!important'],
        color: theme.colorText
      },
      '& .wavesurfer-handle': {
        backgroundColor: ['currentColor', '!important'],
        width: [1, '!important']
      },
      '& cursor': {
        borderRightColor: [theme.bgCardQuaternary, '!important']
      },
      '& showtitle': {
        zIndex: [6, '!important']
      },
      '& showtitle div': {
        position: 'relative',
        visibility: ['visible', '!important'],
        backgroundColor: theme.colorText,
        color: theme.bgCard,
        padding: 2,
        fontSize: 10,
        fontFamily: theme.fontPrimary
      }
    },
    playerLoading: {
      visibility: 'hidden'
    },
    heading: {
      display: 'flex',
      textAlign: 'left'
    },
    label: {
      display: 'block',
      padding: [[0, 3]],
      position: 'absolute',
      bottom: 0,
      left: 1,
      zIndex: 10,
      fontWeight: 'bold',
      fontFamily: theme.fontSecondary,
      fontSize: '0.7em',
      textTransform: 'uppercase',
      color: '#000',
      userSelect: 'none',
      background: theme.bgHighlight
    },
    remove: {
      position: 'absolute',
      top: 3,
      right: 3,
      color: theme.bgCard,
      background: theme.colorText,
      display: 'block',
      fontSize: 12,
      fontFamily: 'sans-serif',
      fontWeight: 'bold',
      lineHeight: 1.1,
      width: 14,
      height: 14,
      textAlign: 'center',
      borderRadius: '50%',
      cursor: 'pointer'
    },
    shortcuts: {
      display: 'block',
      width: '100%',
      outline: 0
    },
    loading: {
      textAlign: 'center',
      fontSize: 16,
      fontStyle: 'italic',
      position: 'absolute',
      top: 0,
      left: 0,
      padding: 20,
      width: '100%'
    },
    minimap: {
      paddingTop: 25
    },
    hidden: {
      opacity: 0
    },
    slider: {
      margin: [[0, 20, 0, 10]],
      width: 100,
      cursor: 'grab'
    },
    video: {
      cursor: 'pointer'
    }
  };
};

var AudioCard = (_dec = (0, _util.withStyles)(styles, {
  withTheme: true
}), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(AudioCard, _React$Component);

  function AudioCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AudioCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AudioCard.__proto__ || Object.getPrototypeOf(AudioCard)).call.apply(_ref, [this].concat(args))), _this), _this.keymap = 'AUDIO', _this.state = {
      selected: null,
      spans: [],
      ready: false,
      loop: false,
      loopRegion: false,
      isVideo: true,
      MEDIA_KEY: 'audio',
      MEDIA_SPANS_KEY: 'audio_spans'
    }, _this.ws = null, _this.componentDidMount = function () {
      var _this$props = _this.props,
          theme = _this$props.theme,
          config = _this$props.config,
          content = _this$props.content,
          isManual = _this$props.isManual;
      var MEDIA_SPANS_KEY = _this.state.MEDIA_SPANS_KEY;

      var _this$getMediaType = _this.getMediaType(content),
          MEDIA_KEY = _this$getMediaType.MEDIA_KEY,
          isVideo = _this$getMediaType.isVideo;

      _this.setState({
        origSpans: content[MEDIA_SPANS_KEY],
        MEDIA_KEY: MEDIA_KEY,
        isVideo: isVideo,
        loop: config.audioLoop
      });

      if (config.labels && config.labels.length) {
        _this.setState({
          label: config.labels[0]
        });
      }

      var showTimeline = config.audioTimeline;
      var showMinimap = config.audioMinimap;
      Promise.all([import('wavesurfer.js'), import('wavesurfer.js/dist/plugin/wavesurfer.cursor.js'), import('wavesurfer.js/dist/plugin/wavesurfer.regions.js'), import('wavesurfer.js/dist/plugin/wavesurfer.timeline.js'), import('wavesurfer.js/dist/plugin/wavesurfer.minimap.js')]).then(function (res) {
        var resolved = res.map(function (_ref2) {
          var importedModule = _ref2["default"];
          return importedModule;
        });

        var _resolved = _slicedToArray(resolved, 5),
            WaveSurfer = _resolved[0],
            CursorPlugin = _resolved[1],
            RegionsPlugin = _resolved[2],
            TimelinePlugin = _resolved[3],
            MinimapPlugin = _resolved[4];

        _this.ws = WaveSurfer.create({
          container: _this.player,
          backend: isVideo ? 'MediaElement' : 'WebAudio',
          scrollParent: true,
          barWidth: config.audioBarWidth,
          barHeight: config.audioBarHeight,
          barGap: config.audioBarGap,
          barRadius: config.audioBarRadius,
          audioRate: config.audioRate,
          waveColor: theme.colorText,
          progressColor: theme.bgCardTitle,
          plugins: [CursorPlugin.create({
            showTime: true,
            deferInit: !config.audioCursor,
            opacity: 1,
            customShowTimeStyle: {
              display: config.audioCursorTime ? undefined : 'none'
            }
          }), TimelinePlugin.create({
            container: _this.timeline,
            deferInit: !showTimeline,
            fontFamily: theme.fontPrimary,
            notchPercentHeight: 40,
            primaryColor: theme.colorText,
            primaryFontColor: theme.colorText
          }), RegionsPlugin.create({
            dragSelection: isManual,
            slop: 2
          }), MinimapPlugin.create({
            container: _this.minimap,
            waveColor: theme.bgCardQuaternary,
            progressColor: theme.colorText,
            height: 15,
            barWidth: 1,
            barGap: 1,
            deferInit: !showMinimap
          })]
        });

        _this.loadMedia(content);

        _this.ws.on('ready', function () {
          _this.setState({
            ready: true
          });

          _this.setupRegions(_this.props.content[MEDIA_SPANS_KEY]);

          if (_this.props.config.audioAutoplay) {
            _this.ws.play();
          }
        });

        _this.ws.on('audioprocess', function () {
          if (!_this.state.isPlaying && _this.ws.isPlaying()) {
            _this.setState({
              isPlaying: true
            });
          }
        });

        _this.ws.on('play', function () {
          _this.setState({
            isPlaying: true
          });
        });

        _this.ws.on('pause', function () {
          _this.setState({
            isPlaying: false
          });
        });

        _this.ws.on('finish', function () {
          if (_this.state.loop) {
            _this.setState({
              isPlaying: true
            });

            _this.ws.play();
          }
        });

        _this.ws.on('region-click', function (region, event) {
          // https://github.com/katspaugh/wavesurfer.js/blob/master/example/annotation/app.js
          event.stopPropagation();
          region.play();
        }); // this.ws.on('region-play', region => {
        //     region.once('out', () => {
        //         this.ws.play(region.start)
        //         this.ws.pause()
        //     });
        // })


        if (_this.props.isManual) {
          _this.ws.on('region-created', function (region) {
            // Replace wavesurfer ID with Prodigy-style ID
            if (region.id.startsWith('wavesurfer_')) {
              region.id = (0, _v2["default"])();
            }
          });

          _this.ws.on('region-update-end', function (region) {
            var label = region.label || _this.state.label;

            _this.setRegionColor(region, _this.getColor(label));

            _this.addRegionLabel(region, label, true);

            _this.updateSpan(region.id, _this.regionToSpan(region));
          });
        }
      });
    }, _this.componentWillUnmount = function () {
      _this.ws.pause();
    }, _this.componentDidUpdate = function (prev) {
      var content = _this.props.content;

      var _this$getMediaType2 = _this.getMediaType(content),
          MEDIA_KEY = _this$getMediaType2.MEDIA_KEY,
          isVideo = _this$getMediaType2.isVideo;

      if (prev.content && prev.content[_constants.TASK_ID] != content[_constants.TASK_ID]) {
        _this.ws.pause();

        _this.setState({
          ready: false,
          MEDIA_KEY: MEDIA_KEY,
          isVideo: isVideo
        }, function () {
          _this.loadMedia(content);
        });
      }
    }, _this.handlePlayPause = function () {
      _this.ws.playPause();
    }, _this.handleLoop = function () {
      var loop = _this.state.loop;

      var isPlaying = _this.ws.isPlaying();

      if (loop && isPlaying) {
        _this.ws.pause();
      }

      _this.setState({
        loop: !loop
      });
    }, _this.handleReset = function () {
      if (_this.props.isManual) {
        _this.setupRegions(_this.state.origSpans);
      }
    }, _this.handleZoomFocus = function () {
      if (_this.zoomSlider) _this.zoomSlider.focus();
    }, _this.handleZoom = function (_ref3) {
      var target = _ref3.target;
      var level = Number(target.value);

      _this.ws.zoom(level);
    }, _this.removeSpan = function (spanId) {
      var spans = _this.state.spans;
      var newSpans = spanId ? spans.filter(function (s) {
        return s.id !== spanId;
      }) : spans;

      _this.updateSpans(newSpans);
    }, _this.updateSpans = function (spans) {
      _this.setState({
        spans: spans
      });

      _this.props.update(_defineProperty({}, _this.state.MEDIA_SPANS_KEY, spans));
    }, _this.updateSpan = function (spanId, updates) {
      // Update an existing span
      var spans = _this.state.spans;
      var index = spans.map(function (span) {
        return span.id;
      }).indexOf(spanId);
      var current = spans.find(function (s) {
        return s.id == spanId;
      });
      var prevSpans = spans.filter(function (s) {
        return s.id !== spanId;
      });

      var newSpan = _extends({}, current, updates); // Insert new span at its old position


      var newSpans = (0, _util.insertInto)(prevSpans, newSpan, index);

      _this.updateSpans(newSpans);
    }, _this.regionToSpan = function (region) {
      return {
        start: region.start,
        end: region.end,
        label: region.label,
        id: region.id || (0, _v2["default"])(),
        color: region.color || _this.getColor(region.label)
      };
    }, _this.setupRegions = function () {
      var spans = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var isManual = _this.props.isManual;

      _this.ws.clearRegions();

      var newSpans = spans.map(function (obj) {
        return _this.regionToSpan(obj);
      });

      _this.updateSpans(newSpans);

      newSpans.forEach(function (obj) {
        var region = _this.ws.addRegion(_extends({}, obj, {
          id: obj.id || (0, _v2["default"])(),
          drag: isManual,
          resize: isManual
        }));

        _this.setRegionColor(region, obj.color);

        _this.addRegionLabel(region, obj.label, isManual);
      });
    }, _this.addRegionLabel = function (region, label, addDeleteButton) {
      var _this$props2 = _this.props,
          classes = _this$props2.classes,
          translate = _this$props2.translate;

      if (!region.label) {
        var el = region.element;
        var span = el.appendChild(document.createElement('span'));
        var color = (0, _util.getAlphaColor)(region.color, 1.0);
        var contrastColor = (0, _util.getContrastColor)(region.color);
        span.textContent = label;
        span.className = classes.label;
        span.style.color = contrastColor;
        span.style.background = color;
        region.label = label;
        var regionWidth = region.wrapper.querySelector('canvas').clientWidth;
        var regionOffset = region.element.offsetLeft;

        if (regionOffset + span.clientWidth > regionWidth) {
          // The label is wider than the full waveform, align it right
          // so it doesn't cause overflow
          span.style.right = 0;
          span.style.left = 'initial';
        }

        if (addDeleteButton && !region.hasDeleteButton) {
          var button = el.appendChild(document.createElement('span'));
          button.textContent = '×';
          button.title = translate('delete_region', 'Delete region');
          button.addEventListener('click', function (event) {
            event.stopPropagation();

            _this.removeSpan(region.id);

            region.remove();
          });
          button.className = classes.remove;
          button.style.background = color;
          button.style.color = contrastColor;
          region.hasDeleteButton = true;
        }
      }
    }, _this.handleShortcuts = function (action) {
      switch (action) {
        case 'playpause':
          _this.handlePlayPause();

          break;

        case 'reset':
          _this.handleReset();

          break;

        case 'loop':
          _this.handleLoop();

          break;

        case 'zoom':
          _this.handleZoomFocus();

          break;
      }
    }, _this.getColor = function (label) {
      var isManual = _this.props.isManual;
      var _this$props$config = _this.props.config,
          labels = _this$props$config.labels,
          labelColors = _this$props$config.labelColors;

      if (labelColors[label]) {
        return labelColors[label];
      }

      var index = labels.indexOf(label);
      var i = index !== -1 ? index : isManual ? labels.length + 1 : 0;
      return (0, _util.getColor)(_constants.AUDIO_COLORS, i);
    }, _this.setRegionColor = function (region, color) {
      if (color) {
        region.color = (0, _util.getAlphaColor)(color, 0.2);
        region.element.style.color = color;
        region.updateRender();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AudioCard, [{
    key: 'getMediaType',
    value: function getMediaType(content) {
      var MEDIA_KEY = content.video ? 'video' : 'audio';
      var isVideo = MEDIA_KEY === 'video';
      return {
        MEDIA_KEY: MEDIA_KEY,
        isVideo: isVideo
      };
    }
  }, {
    key: 'loadMedia',
    value: function loadMedia(content) {
      if (this.state.isVideo && this.video) {
        this.ws.load(this.video);
      } else {
        this.ws.load(content[this.state.MEDIA_KEY]);
      }
    } // handleLoopRegion = () => {
    //     const { loopRegion } = this.state
    //     const isPlaying = this.ws.isPlaying()
    //     if (loopRegion && isPlaying) {
    //         this.ws.pause()
    //     }
    //     this.setState({ loopRegion: !loopRegion })
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          ToolbarButton = _props.ToolbarButton,
          isManual = _props.isManual,
          content = _props.content,
          config = _props.config,
          nowrap = _props.nowrap,
          classes = _props.classes,
          translate = _props.translate,
          children = _props.children;
      var cardStyle = config.cardStyle,
          labelStyle = config.labelStyle,
          labels = config.labels,
          audioMinimap = config.audioMinimap;
      var _state = this.state,
          isPlaying = _state.isPlaying,
          label = _state.label,
          ready = _state.ready,
          loop = _state.loop,
          loopRegion = _state.loopRegion,
          isVideo = _state.isVideo;
      var LabelComponent = labelStyle == 'dropdown' ? _LabelDropdown2["default"] : _LabelList2["default"];

      var toolbar = _react2["default"].createElement(_util.ShortcutsWrapper, {
        ctx: this.context.shortcuts,
        className: classes.shortcuts,
        name: this.keymap,
        handler: this.handleShortcuts,
        targetNodeSelector: 'body',
        global: true
      }, _react2["default"].createElement(_Toolbar.Toolbar, null, _react2["default"].createElement('div', null, _react2["default"].createElement(ToolbarButton, {
        id: isPlaying ? 'pause' : 'play',
        title: isPlaying ? translate('audio_pause', 'pause') : translate('audio_play', 'play'),
        onClick: this.handlePlayPause,
        disabled: !ready,
        keyName: (0, _util.getKeyName)(this.context, this.keymap, 'playpause')
      }), _react2["default"].createElement(ToolbarButton, {
        id: 'loop',
        title: translate('audio_loop', 'loop'),
        active: loop,
        onClick: this.handleLoop,
        keyName: (0, _util.getKeyName)(this.context, this.keymap, 'loop')
      })), isManual && _react2["default"].createElement('div', null, _react2["default"].createElement(_Icon2["default"], {
        name: 'zoom',
        size: 20
      }), _react2["default"].createElement('input', {
        type: 'range',
        min: '20',
        max: this.props.config.audioMaxZoom,
        step: this.props.config.audioMaxZoom / 50,
        onInput: this.handleZoom,
        className: classes.slider,
        ref: function ref(x) {
          _this2.zoomSlider = x;
        }
      }), _react2["default"].createElement(ToolbarButton, {
        id: 'reset',
        onClick: this.handleReset,
        disabled: !ready,
        title: translate('reset'),
        keyName: (0, _util.getKeyName)(this.context, this.keymap, 'reset')
      }))));

      var playerClassNames = (0, _classnames2["default"])(classes.player, _defineProperty({}, classes.playerLoading, !ready));
      return _react2["default"].createElement(_react.Fragment, null, isManual ? _react2["default"].createElement(_shared.Heading, {
        toolbar: toolbar,
        classes: {
          _root: classes.heading
        },
        hasLabels: true
      }, _react2["default"].createElement(LabelComponent, {
        labels: labels,
        selected: label,
        handleSelect: function handleSelect(label) {
          return _this2.setState({
            label: label
          });
        },
        keymap: config.labelKeymap
      })) : toolbar, _react2["default"].createElement(_shared.Content, {
        cardStyle: cardStyle,
        nowrap: nowrap
      }, isVideo && _react2["default"].createElement('video', {
        ref: function ref(x) {
          _this2.video = x;
        },
        src: content[this.state.MEDIA_KEY],
        width: content.width || '100%',
        height: content.height || 'auto',
        type: 'video/mpeg',
        className: classes.video,
        onClick: this.handlePlayPause
      }), _react2["default"].createElement('div', {
        className: playerClassNames,
        ref: function ref(x) {
          _this2.player = x;
        }
      }, !ready && _react2["default"].createElement('div', {
        className: classes.loading
      }, translate('loading_audio', 'Loading audio...'))), _react2["default"].createElement('div', {
        ref: function ref(x) {
          _this2.timeline = x;
        }
      }), audioMinimap && _react2["default"].createElement('div', {
        ref: function ref(x) {
          _this2.minimap = x;
        },
        className: (0, _classnames2["default"])(classes.minimap, _defineProperty({}, classes.hidden, !ready))
      })), children);
    }
  }]);

  return AudioCard;
}(_react2["default"].Component), _class2.id = 'audio', _class2.contextTypes = {
  shortcuts: _propTypes2["default"].object
}, _class2.defaultProps = {
  ToolbarButton: _Toolbar.ToolbarButton,
  isManual: false,
  config: {}
}, _temp2)) || _class);

var Audio = exports.Audio = function Audio(props) {
  return _react2["default"].createElement(AudioCard, _extends({}, props, {
    isManual: false
  }));
};

var AudioManual = exports.AudioManual = function AudioManual(props) {
  return _react2["default"].createElement(AudioCard, _extends({}, props, {
    isManual: true
  }));
};